export default async function getMenuData() {
  return [
    {
      category: true,
      title: 'Dashboards',
    },
    {
      title: 'Dashboard',
      key: 'dashboard',
      url: '/dashboard/franchise',
      roles : ['franchise']
    },
    {
      title: 'Dashboard Investor',
      key: 'dashboardInvestor',
      url: '/dashboard/beta',
      roles : ['investor']
    },
    {
      title: 'Dashboard SuperAdmin',
      key: 'superAdmin',
      url: '/dashboard/super',
      roles : ['admin']
    },

    {
      category: true,
      title: 'Manage',
    },

    {
      title: 'Properties',
      key: 'Properties',
      url: '/properties',
      roles: ['franchise'],
    },
    {

      title: 'Investors',
      key: 'Investors',
      url: '/investors',
      roles: ['franchise'],
    }
  ]
}
